import { render, staticRenderFns } from "./score-details.vue?vue&type=template&id=67c2a2dd&scoped=true"
import script from "./score-details.vue?vue&type=script&lang=js"
export * from "./score-details.vue?vue&type=script&lang=js"
import style0 from "./score-details.vue?vue&type=style&index=0&id=67c2a2dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c2a2dd",
  null
  
)

export default component.exports